import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  FormControl,
  FormLabel,
  TextField,
  Divider,
  Typography,
} from '@mui/material';
import { ListaContainerTopico } from './ListaContainerTopico';
// Remove unused import

type AcessoContainer = {
  id?: string;
  mensageriaId?: string;
  tipo: number;
  direcao: number;
};

type Mensageria = {
  id?: string;
  nomeTopico: string;
  acessoContainers?: AcessoContainer[];
};

type Props = {
  open: boolean;
  onClose: () => void;
  onSave?: (values: Mensageria, editId?: string) => void;
  initialValues?: {
    id?: string;
    nomeTopico?: string;
    acessoContainers?: AcessoContainer[];
  };
};

export const ModalMensageria: React.FC<Props> = ({
  open,
  onClose,
  onSave,
  initialValues,
}) => {
  const [nomeTopico, setNomeTopico] = useState<string>('');
  const [acessoContainers, setAcessoContainers] = useState<AcessoContainer[]>(
    []
  );
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (open) {
      if (initialValues) {
        setNomeTopico(initialValues.nomeTopico || '');
        setAcessoContainers(initialValues.acessoContainers || []);
      } else {
        setNomeTopico('');
        setAcessoContainers([]);
      }
    }
  }, [open, initialValues]);

  useEffect(() => {
    setIsValid(Boolean(nomeTopico?.trim()));
  }, [nomeTopico]);

  const handleSave = () => {
    if (!nomeTopico?.trim()) {
      return;
    }

    const values: Mensageria = {
      id: initialValues?.id || String(Date.now()),
      nomeTopico: nomeTopico.trim(),
      acessoContainers: acessoContainers,
    };

    if (onSave) {
      onSave(values, initialValues?.id);
      handleClose(); // Fechar modal após salvar
    }
  };

  const handleClose = () => {
    setNomeTopico('');
    setAcessoContainers([]);
    onClose();
  };

  const handleContainersChange = (containers: AcessoContainer[]) => {
    setAcessoContainers(containers);
  };

  return (
    <Dialog open={!!open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>
        {initialValues?.id ? 'Editar Mensageria' : 'Nova Mensageria'}
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection="column" gap={3}>
          <FormControl>
            <FormLabel required>Nome do Tópico</FormLabel>
            <TextField
              fullWidth
              variant="outlined"
              value={nomeTopico}
              onChange={(e) => setNomeTopico(e.target.value)}
              placeholder="Ex: pedidos.created, usuarios.updated"
            />
          </FormControl>

          <Divider />

          <Box>
            <Typography variant="h6" gutterBottom>
              Containers
            </Typography>
            <ListaContainerTopico
              initialRows={acessoContainers}
              onContainersChange={handleContainersChange}
              mensageriaId={initialValues?.id}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          color="primary"
          disabled={!isValid}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
